<div class="h-full min-h-0 overflow-y-auto">
  <div class="flex flex-col gap-3 pb-4 sm:gap-4 sm:pb-6">
    <!-- HEADER -->
    <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <!-- Botones -->
      <div class="flex flex-wrap items-stretch gap-2 sm:items-center">
        <button
          class="flex min-w-36 flex-1 items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-sm font-semibold shadow-md transition sm:flex-none sm:px-6 sm:py-3 sm:text-base"
          [class.bg-amber-600]="modoEdicion()"
          [class.hover:bg-amber-700]="modoEdicion()"
          [class.bg-slate-600]="!modoEdicion()"
          [class.hover:bg-slate-700]="!modoEdicion()"
          [class.text-white]="true"
          (click)="modoEdicion() ? guardarCambiosOrden() : toggleModoEdicion()"
        >
          @if (modoEdicion()) {
            <span aria-hidden="true">✓</span>
            <span class="hidden sm:inline">Guardar Orden</span>
            <span class="sm:hidden">Guardar</span>
          } @else {
            <span aria-hidden="true">⚙️</span>
            <span>Editar</span>
          }
        </button>

        @if (modoEdicion()) {
          <button
            class="flex min-w-36 flex-1 items-center justify-center gap-2 rounded-lg bg-red-600 px-4 py-2.5 text-sm font-semibold text-white shadow-md transition hover:bg-red-700 sm:flex-none sm:px-6 sm:py-3 sm:text-base"
            (click)="cancelarCambiosOrden()"
          >
            <span aria-hidden="true">✕</span>
            <span class="hidden sm:inline">Cancelar Orden</span>
            <span class="sm:hidden">Cancelar</span>
          </button>
        }
      </div>

      <!-- Nueva Mesa -->
      <button
        class="w-full rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white shadow-md transition hover:bg-blue-700 sm:w-auto sm:px-6 sm:py-3 sm:text-base"
        (click)="modal_crear_comanda.set(true)"
      >
        <i class="bi bi-plus-lg mr-1" aria-hidden="true"></i>
        Nueva Mesa
      </button>
    </div>

    <!-- ALERTA -->
    @if (modoEdicion()) {
      <div class="p-3 sm:p-4 bg-amber-50 border-l-4 border-amber-500 rounded-lg">
        <div class="flex items-start gap-2 sm:gap-3">
          <span class="text-xl">👆</span>
          <div>
            <p class="font-semibold text-amber-800 text-sm sm:text-base">
              Modo de Edición Activado
            </p>
            <p class="text-xs sm:text-sm text-amber-700 mt-1">
              Arrastra las tarjetas para cambiar el orden.
            </p>
          </div>
        </div>
      </div>
    }

    <!-- GRID -->
    <div
      cdkDropList
      cdkDropListOrientation="mixed"
      [cdkDropListAutoScrollDisabled]="false"
      (cdkDropListDropped)="onDrop($event)"
      class="grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 p-1"
    >
      @for (mesa of mesas(); track mesa.id) {
        <div
          cdkDrag
          [cdkDragDisabled]="!modoEdicion()"
          (click)="!modoEdicion() && verComanda(mesa)"
        >
          <app-card-comanda
            [mesa]="mesa"
            [modoEdicion]="modoEdicion()"
            (editar)="abrirEditarMesa($event)"
          />
        </div>
      } @empty {
        <div
          class="col-span-full flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-slate-200 bg-white/70 px-6 py-10 text-center"
        >
          <i class="bi bi-grid-3x3-gap text-3xl text-slate-300" aria-hidden="true"></i>
          <div class="space-y-1">
            <p class="font-semibold text-slate-700">Aún no hay mesas</p>
            <p class="text-sm text-slate-500">
              Crea la primera mesa para comenzar a tomar comandas.
            </p>
          </div>
          <button
            class="rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-md transition hover:bg-blue-700"
            type="button"
            (click)="modal_crear_comanda.set(true)"
          >
            <i class="bi bi-plus-lg mr-1" aria-hidden="true"></i>
            Nueva Mesa
          </button>
        </div>
      }
    </div>
  </div>
</div>

<app-dialog
  header="Comanda - {{
    mesa_seleccionada() ? `${mesa_seleccionada()!.nombre} - ${mesa_seleccionada()!.numero + 1}` : ''
  }}"
  [(visible)]="modal_ver_comanda"
  [modal]="true"
  [closable]="true"
  (onHide)="verComanda(null)"
  size="8xl"
>
  @if (modal_ver_comanda() == true) {
    <app-ver-comanda [(mesa)]="mesa_seleccionada" (cerrar)="modal_ver_comanda.set(false)" />
  }
</app-dialog>

<app-dialog
  header="Crear Comanda"
  [(visible)]="modal_crear_comanda"
  [modal]="true"
  [closable]="true"
  (onHide)="modal_crear_comanda.set(false)"
  size="md"
>
  <app-agregar-mesa (cerrar)="modal_crear_comanda.set(false)" />
</app-dialog>

<app-dialog
  header="Editar Mesa"
  [(visible)]="modal_editar_mesa"
  [modal]="true"
  [closable]="true"
  (onHide)="modal_editar_mesa.set(false)"
  size="sm"
>
  @if (modal_editar_mesa() && mesa_a_editar()) {
    <app-agregar-mesa [mesaEditar]="mesa_a_editar()!" (cerrar)="onCerrarEditarMesa($event)" />
  }
</app-dialog>
